import React from 'react';

const Home = React.lazy(() => import('pages/Home'));
const InviteFriends = React.lazy(() => import('pages/invite/inviteFriends'));
const VerifyEmail = React.lazy(() => import('components/verifyEmail/verifyEmail'));
const PolicyPage = React.lazy(() => import('pages/policy/policyPage'));
const AffiliatePage = React.lazy(() => import('pages/affiliate/affiliatePage'));
const GamePlay = React.lazy(() => import('pages/gamePlay/gamePlay'));
const GoogleAuthCallback = React.lazy(() => import('pages/auth/googleCallback'));
const SportsbookLaunch = React.lazy(() => import('pages/sports/SportsbookLaunch'));
const ResetPassword = React.lazy(() => import('pages/auth/ResetPassword'));
const CasinoCategory = React.lazy(() => import('components/casinoCategory/casinoCategory'));
const NotFound = React.lazy(() => import('pages/notFound/NotFound'));
const CasinoProvider = React.lazy(() => import('components/casinoProvider/casinoProvider'));
const AllProviders = React.lazy(() => import('components/allProviders/allProviders'));
const DailySpinPage = React.lazy(() => import('pages/dailySpin/dailySpinPage'));

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

/**
 * Routes that do not use the main Layout
 */
export const standaloneRoutes: RouteConfig[] = [
  {
    path: '/auth/google/callback',
    element: <GoogleAuthCallback />,
  },
];

/**
 * Routes that use the main Layout but are public
 */
export const publicLayoutRoutes: RouteConfig[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/modal=/*',
    element: <Home />,
  },
  {
    path: '/daily-spin',
    element: <DailySpinPage />,
  },
  {
    path: '/sports',
    element: <SportsbookLaunch />,
  },
  {
    path: '/policy/:policyId',
    element: <PolicyPage />,
  },
  {
    path: '/affiliate',
    element: <AffiliatePage />,
  },
  {
    path: '/casino/categories/:category',
    element: <CasinoCategory />,
  },
  {
    path: '/casino/providers/:providerId',
    element: <CasinoProvider />,
  },
  {
    path: '/casino/providers',
    element: <AllProviders />,
  },
  {
    path: '/game/casino/:game',
    element: <GamePlay />,
  },
  {
    path: '/verify-email',
    element: <VerifyEmail />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

/**
 * Routes that use the main Layout and require authentication
 */
export const protectedLayoutRoutes: RouteConfig[] = [
  {
    path: '/invite-friends',
    element: <InviteFriends />,
  },
];
